import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo } from 'react';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { ClockOutlinedSize16, CalendarOutlinedSize16, ClockOutlinedSize24, CalendarOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';
import { BaseInput } from './BaseInput.js';
import { useDateTimeMask } from './useDateTimeMask.js';
import 'classnames';
import '@hh.ru/magritte-common-mouse';
import '@hh.ru/magritte-common-text-selection';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-form-helper';
import './useFocus.js';
import './useInputAriaProps.js';
import '@hh.ru/magritte-ui-typography';
import './index.esm-BUgPQlrr.js';

const DateTimeInput = forwardRef(({ dateMask, timeMask, timeRounding, onButtonClick, hideMask, size, ...props }, ref) => {
    const maskedInputRef = useDateTimeMask(dateMask, timeMask, timeRounding);
    const inputRef = useMultipleRefs(maskedInputRef, ref);
    const onBlur = dateMask === 'dd'
        ? (event) => {
            if (props.value.length === 1) {
                if (props.value === '0') {
                    props.onChange('');
                }
                else {
                    props.onChange(props.value.padStart(2, '0'));
                }
            }
            props.onBlur?.(event);
        }
        : props.onBlur;
    const maskedPlaceholder = useMemo(() => {
        if (hideMask) {
            return undefined;
        }
        const parts = [];
        if (dateMask) {
            parts.push(dateMask.replace(/d/g, 'Д').replace(/m/g, 'М').replace(/y/g, 'Г'));
        }
        if (timeMask) {
            parts.push('00:00');
        }
        return parts.join(', ');
    }, [dateMask, timeMask, hideMask]);
    return (jsx(BaseInput, { type: "text", inputMode: "decimal", fixedPlaceholder: maskedPlaceholder, ...props, ...((onButtonClick &&
            (size === 'small'
                ? {
                    buttonIcon: timeMask && !dateMask ? ClockOutlinedSize16 : CalendarOutlinedSize16,
                    onButtonClick,
                }
                : {
                    buttonIcon: timeMask && !dateMask ? ClockOutlinedSize24 : CalendarOutlinedSize24,
                    onButtonClick,
                })) ??
            {}), ref: inputRef, size: size, autoComplete: "off", onBlur: onBlur }));
});
DateTimeInput.displayName = 'DateTimeInput';

export { DateTimeInput };
//# sourceMappingURL=DateTimeInput.js.map
